import React, { useEffect } from "react";
import * as Routes from "./routes/Routes";
import configRouters from "Configs/routes";
import { Route, Switch, withRouter } from "react-router-dom";
import withDefaultParams from "Services/withDefaultParams";
import OperatorsLayout from "Layouts/OperatorLayout";
import { observer, inject } from "mobx-react";
import { Redirect404 } from "ComponentsUI/Redirects";

const Operators = (props) => {
	// Закрыть модальное окно, если оно открыто во время перехода на данную страницу
	useEffect(() => {
		const modal = props.ApplicationModel.modalModel;
		if (modal.isOpen) {
			modal.toggleModal();
		}
	}, [props.match.url]);

	return (
		<Switch>
			<OperatorsLayout
				exact
				path={configRouters.OperatorDetails.route}
				seoData={props.seoData}
				component={Routes.AboutOperator}
				seoPath="OperatorDetails"
			/>
			<OperatorsLayout
				exact
				path={configRouters.OperatoryTariffs.route}
				seoData={props.seoData}
				component={Routes.RatesMobile}
				seoPath="OperatoryTariffs"
			/>
			<OperatorsLayout
				exact
				path={configRouters.OperatoryBeautifulNumbers.route}
				seoData={props.seoData}
				component={Routes.BeautifulNumbers}
				seoPath="OperatoryBeautifulNumbers"
			/>
			<OperatorsLayout
				exact
				path={configRouters.OperatoryActions.route}
				seoData={props.seoData}
				component={Routes.Actions}
				seoPath="OperatoryActions"
			/>
			<Route render={Redirect404} />
		</Switch>
	);
};

export default withRouter(withDefaultParams(inject("ApplicationModel")(observer(Operators))));
